package com.anjuros.website.templates.template1.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.selection.util.Res
import com.anjuros.website.templates.template1.modules.Template1Section
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.modules.getColor
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ScrollSnapAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Text



@Composable
fun Template1MobileMenu(
    onClose: () -> Unit
) {

    Box(
        modifier = Modifier
        .position(Position.Absolute)
            .top(60.px)
            .zIndex(6.0)
            .left(0.px)
            .fillMaxWidth()
            .backgroundColor(Colors.White)
            .padding(
                top = 18.px,
                bottom = 25.px,
                leftRight = 22.px
            )
            .border(
                width = 1.px,
                color = Template1Theme.Primary.getColor(),
                style = LineStyle.Solid
            )
            .boxShadow(
                offsetY = 15.px,
                blurRadius = 30.px,
                color = rgba(0, 0, 0, 0.4)
            )
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
                .margin(top=10.px)

        ) {
            Template1Section.entries.forEach { section ->
                Template1MobileMenuLink(
                    section,
                    onClick = onClose
                )
            }
        }
        Image(
            modifier =  Modifier
                .cursor(Cursor.Pointer)
                .align(Alignment.TopEnd)
                .color(Template1Theme.Primary.getColor())
                .onClick {
                    onClose()
                },
            src = Res.Icon.icon_x,
            alt = "Close menu"
        )
    }
}


@Composable
private fun Template1MobileMenuLink(
   section: Template1Section,
    onClick: () -> Unit
) {

    A(
        href = section.path,
        attrs = Modifier
            .fillMaxWidth()
            .padding(
                topBottom = 15.px
            )
            .borderBottom(
                1.px,
                LineStyle.Solid,
                rgb(238, 233, 229)
            )
            .fontSize(16.px)
            .fontWeight(FontWeight.Medium)
            .color(
                Template1Theme.Primary.getColor()
            )
            .textDecorationLine(TextDecorationLine.None)
            .onClick {
                onClick()
            }
            .toAttrs()
    ) {
        Text(
            LocalText(section.title)
        )
    }
}

